<template>
        <div class="data-card">
            
            <div class="card-title card-title-wrapper">{{ title }}</div>
            
            <div class="data-grid">
                <div class="data-block" v-for="item in dataList" :key="item.label">
                    <div class="label">{{ item.label }}</div>
                    <div class="value">{{ item.value }}</div>
                </div>
            </div>
        </div>
</template>

<script setup>
const props = defineProps({
    title: {
        type: String,
        default: '实时数据量'
    }
})

const dataList = [
    { label: '当日实时数据', value: '8507个' },
    { label: '环比增长', value: '+2%' },
    { label: '全量占比', value: '80%' },
    { label: '昨日数据总量', value: '14779个' },
    { label: '本月累计总量', value: '141414个' },
    { label: '上月累计总量', value: '314134个' },
]
</script>

<style scoped>
.data-card {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.card-title-wrapper {
  background: linear-gradient(90deg, rgba(0, 38, 66, 0.5), #024d7f, rgba(0, 38, 66, 0.5));
  padding: 4px;
  /* border-radius: 8px; */
  /* box-shadow: 0 0 12px rgba(0, 255, 255, 0.4); */
  text-align: center;
}

.card-title {
    font-size: 20px;
    font-weight: bold;
    color: #00ffff;
    /* text-shadow: 0 0 6px #00ffff; */
    border-left: 2px solid #00ffff;
    border-right: 2px solid #00ffff;
    padding-left: 10px;
    margin-bottom: 8px;
}

.data-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.data-block {
    background: rgba(0, 51, 102, 0.3);
    border: 0px solid rgba(0, 255, 255, 0.2);
    border-radius: 6px;
    padding: 10px;
    box-shadow: 0 0 8px rgba(0, 255, 255, 0.1);
    transition: transform 0.3s;
}

.data-block:hover {
    transform: scale(1.02);
}

.label {
    font-size: 13px;
    color: #99ccff;
    margin-bottom: 4px;
}

.value {
    font-size: 18px;
    font-weight: bold;
    color: #ffffff;
    text-shadow: 0 0 4px #00eaff;
}
</style>
